import { getConfig } from "@/get-config";

const LoaderIconAnimated = ({ fullScreen }) => {
  const { cdnAssetUrl } = getConfig();
  return (
    <div
      className={`flex justify-center items-center ${
        fullScreen ? "h-screen" : ""
      }`}>
      <div className={`relative ${fullScreen ? " " : `w-[45%] h-auto`}`}>
        <img
          src={`${cdnAssetUrl}statichome.svg`}
          fetchpriority="high"
          alt="Home"
          className="w-full h-auto"
        />

        <img
          src={`${cdnAssetUrl}earth.svg`}
          fetchpriority="high"
          alt="Earth"
          className="absolute bottom-0 right-0 w-[60%] h-auto animate-slow-spin"
        />
      </div>
    </div>
  );
};

export default LoaderIconAnimated;
